export default __webpack_public_path__ + "static/492-9a7163cb39f53f9ed4f4b2068c272e6c.gif";